angular.module('dialogs')
    .controller('confirmResultsDialogCtrl',
    [
        '$scope', '$modalInstance', 'header', 'msg', 'hasBonusNumber', function ($scope, $modalInstance, header, msg, hasBonusNumber) {

            $scope.header = (angular.isDefined(header)) ? header : 'Confirmation';
            $scope.drawResults = msg;
            $scope.hasBonusNumber = hasBonusNumber;
            console.log($scope.hasBonusNumber);

            $scope.no = function() {
                $modalInstance.dismiss('no');
            };

            $scope.yes = function() {
                $modalInstance.close('yes');
            };
        }
    ]);